import { useCallback, useMemo } from 'react';
import { useAnchorCardContext } from '../context/PlpContext';
import { useRouterContext } from '../context/PlpContext';
import constants from '../utils/constants';
import {
  getQueryParams,
  getQueryString,
  plpCardSizeFilter,
} from '../components/stateful-link/StatefulLink';
import { getAnInViewProduct } from '../utils/getAnInViewProduct';

type PlpCardSizeData = {
  isLargeCard: boolean;
  onViewSelectionChange: (viewName: string) => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const usePlpCardSize = (): PlpCardSizeData => {
  const { setAnchorCard, anchorCard } = useAnchorCardContext();
  const router = useRouterContext();

  const {
    PLP_CARD_SIZES: { SMALL, LARGE },
  } = constants;

  const {
    query: { cardSize, ...queryRest },
    pathname: href,
  } = router;

  const onViewSelectionChange = useCallback(
    (viewName) => {
      const firstCardPid = getAnInViewProduct();

      if (viewName !== SMALL && viewName !== LARGE) return;
      const newPlpCardType = viewName === LARGE ? LARGE : SMALL;

      const newUrl = {
        pathname: href,
        query: getQueryParams(
          { ...queryRest, cardSize: newPlpCardType },
          plpCardSizeFilter()
        ),
      };

      const newAs = `${window.location.pathname}?${getQueryString(newUrl.query)}`;

      router.push(newUrl, newAs, { shallow: true, scroll: false });

      if (window.scrollY) {
        setAnchorCard(firstCardPid);
      } else {
        if (anchorCard) setAnchorCard(null);
      }
    },
    [queryRest, router, SMALL, LARGE]
  );

  const value = useMemo(() => {
    const isLargeCard = !cardSize || cardSize === LARGE;

    return {
      isLargeCard,
      onViewSelectionChange,
    };
  }, [onViewSelectionChange, cardSize, LARGE]);

  return value;
};
